import { useState, useEffect, useContext } from 'react'
import { AdminPageContext } from '../Context'
import Home from './Home'
import ZonalAdmin from './ZonalAdmin'
import LicenseAdmin from './LicenseAdmin'
import UserAdmin from './UserAdmin'
import ReportAdmin from './ReportAdmin'
import RubricAdmin from './RubricAdmin'
import StandardAdmin from './StandardAdmin'
import MagistratAdmin from './MagistratAdmin'
import HospitalAdmin from './HospitalAdmin'
import GarageAdmin from './GarageAdmin'
import DropOffAdmin from './DropOffAdmin'
import PlaceAdmin from './PlaceAdmin'
import LogFile from './LogFile'
import AdminAccess from './AdminAccess'
import DataAdmin from './DataAdmin'
import AlertAdmin from './AlertAdmin'
import MayorAdmin from './MayorAdmin'
import FuneralAdmin from './FuneralAdmin'
import ExaminerAdmin from './ExaminerAdmin'
import JailAdmin from './JailAdmin'
import GuardiaAdmin from './GuardiaAdmin'
import DocsAdmin from './DocsAdmin'
import AppendixAdmin from './AppendixAdmin'
import SubjectAdmin from './SubjectAdmin'
import RecipientAdmin from './RecipientAdmin'
import PhenomenaAdmin from './PhenomenaAdmin'
import BarcodeAdmin from './BarcodeAdmin'
import RegisterAdmin from './RegisterAdmin'
import TypeAdmin from './TypeAdmin'
import StatisticsAdmin from './StatisticsAdmin'
import RestrictionAdmin from './RestrictionAdmin'
import Documentation from './Documentation'

function 
AdminMain() {
  const {adminPage} = useContext(AdminPageContext)
  
  if (adminPage === 'ZonalAdmin') {
    return (
      <ZonalAdmin />
    )
   } else if (adminPage === 'LicenseAdmin') {
    return (
      <LicenseAdmin />
    )
   } else if (adminPage === 'UserAdmin') {
    return (
      <UserAdmin />
    )
   } else if (adminPage === 'ReportAdmin') {
    return (
      <ReportAdmin />
    )
   } else if (adminPage === 'RubricAdmin') {
    return (
      <RubricAdmin />
    )
   } else if (adminPage === 'GuardIAAdmin') {
    return (
      <GuardiaAdmin />
    )
   } else if (adminPage === 'StandardAdmin') {
    return (
      <StandardAdmin />
    )
   } else if (adminPage === 'MagistratAdmin') {
    return (
      <MagistratAdmin />
    )
   } else if (adminPage === 'HospitalAdmin') {
    return (
      <HospitalAdmin />
    )
   } else if (adminPage === 'JailAdmin') {
    return (
      <JailAdmin />
    )
   } else if (adminPage === 'GarageAdmin') {
    return (
      <GarageAdmin />
    )
   } else if (adminPage === 'DropOffAdmin') {
    return (
      <DropOffAdmin />
    )
  } else if (adminPage === 'PlaceAdmin') {  
    return (
      <PlaceAdmin />
    )
   } else if (adminPage === 'MayorAdmin') {
    return (
      <MayorAdmin />
    )
   } else if (adminPage === 'FuneralAdmin') {
    return (
      <FuneralAdmin />
    )
   } else if (adminPage === 'ExaminerAdmin') {
    return (
      <ExaminerAdmin />
    )
   } else if (adminPage === 'LogFile') {
    return (
      <LogFile />
    )
   } else if (adminPage === 'AlertAdmin') {
    return (
      <AlertAdmin />
    )
   } else if (adminPage === 'AdminAccess') {
    return (
      <AdminAccess />
    )
   } else if (adminPage === 'DataAdmin') {
    return (
      <DataAdmin />
    )
   } else if (adminPage === 'DocsAdmin') {
    return (
      <DocsAdmin />
    )
   } else if (adminPage === 'AppendixAdmin') {
    return (
      <AppendixAdmin />
    )
   } else if (adminPage === 'SubjectAdmin') {
    return (
      <SubjectAdmin />
    )
   } else if (adminPage === 'RecipientAdmin') {
    return (
      <RecipientAdmin />
    )
   } else if (adminPage === 'PhenomenaAdmin') {
    return (
      <PhenomenaAdmin />
    )
   } else if (adminPage === 'BarcodeAdmin') {
    return (
      <BarcodeAdmin />
    )
   } else if (adminPage === 'RegisterAdmin') {
    return (
      <RegisterAdmin />
    )
   } else if (adminPage === 'TypeAdmin') {
    return (
      <TypeAdmin />
    )
   } else if (adminPage === 'StatisticsAdmin') {
    return (
      <StatisticsAdmin />
    )
   } else if (adminPage === 'RestrictionAdmin') {
    return (
      <RestrictionAdmin />
    )
   } else if (adminPage === 'Documentation') {
    return (
      <Documentation />
    )
   } else {
    return (
      <Home />
    )
   }

}

export default AdminMain